import Background from './components/background'
import Main from './components/main'
import Navigation from './components/navigation'
import Seo from './components/seo'
import { withBlogPostStore } from './stores/use-blog-post'

const BlogPage = () => {
  return (
    <>
      <Seo />
      <div className='relative overflow-hidden bg-white py-16'>
        <Background />
        <div className='relative px-4 sm:px-6 lg:px-8'>
          <Navigation />
          <Main />
        </div>
      </div>
    </>
  )
}

export default withBlogPostStore(BlogPage)
